export default __webpack_public_path__ + "static/media/slimlenovo.0d70b138.webp";